import { render, staticRenderFns } from "./equipadd.vue?vue&type=template&id=89c2d06e&scoped=true"
import script from "./equipadd.vue?vue&type=script&lang=js"
export * from "./equipadd.vue?vue&type=script&lang=js"
import style0 from "./equipadd.vue?vue&type=style&index=0&id=89c2d06e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89c2d06e",
  null
  
)

export default component.exports